<template>
  <div class="popup-background">
    <div class="popup-window">
      <div class="popup-header">
        <h1 class="popup-title">{{ capitalize($t('confirmLeave')) }}</h1>
      </div>
      <div class="popup-form">
        <div class="form-row">
          <p>{{ $t('selectedResultsLeaveWarning') }}</p>
        </div>
      </div>
      <div class="form-row popup-actions">
        <button @click="confirmLeave" class="input-button input-button-primary">{{ capitalize($t('actions.yes')) }}</button>
        <button @click="cancelLeave" class="input-button">{{ capitalize($t('actions.no')) }}</button>
      </div>
      <div class="popup-close" @click="cancelLeave">&#10006;</div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'modal-leaving-with-results',
  emits: ['close', 'confirm'],
  data: () => ({
    pendingCallback: null
  }),
  methods: {
    open (callback) {
      this.pendingCallback = callback
    },
    confirmLeave () {
      if (this.pendingCallback) {
        this.pendingCallback(true)
      }
      this.$emit('close')
    },
    cancelLeave () {
      if (this.pendingCallback) {
        this.pendingCallback(false)
      }
      this.$emit('close')
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/css/_constants";

  .popup-background {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    align-items: center;
    justify-content: center;
    z-index: 1000;
  }

  .popup-window {
    position: relative;
    background: white;
    border-radius: 8px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    min-width: 400px;
    max-width: 500px;
  }

  .popup-header {
    padding: 20px;
    border-bottom: 1px solid #ddd;

    .popup-title {
      margin: 0;
      font-size: 18px;
      font-weight: bold;
    }
  }

  .popup-form {
    padding: 20px;

    .form-row {
      margin-bottom: 15px;

      &:last-child {
        margin-bottom: 0;
      }

      p {
        margin: 0;
        line-height: 1.5;
      }
    }
  }

  .popup-actions {
    display: flex;
    gap: 10px;
    justify-content: flex-end;
    padding: 20px;
    border-top: 1px solid #ddd;
  }

  .popup-close {
    position: absolute;
    top: 10px;
    right: 10px;
    cursor: pointer;
    font-size: 24px;
    color: #999;
    user-select: none;

    &:hover {
      color: #333;
    }
  }
</style>
